<template>
    <div class="row">
        <section-headline msg="Einen Markt auswählen"></section-headline>
        <div class="col-12">
            <form class="row mb-5" @submit.prevent="submit">
                <div class="col-12 col-md-8">
                    <multiselect v-model="form"
                                 :class="errors.id ? 'error': ''"
                                 :options="merchants"
                                 :multiple="false"
                                 :close-on-select="true"
                                 :clear-on-select="false"
                                 :preserve-search="false"
                                 placeholder="Standort auswählen"
                                 selectedLabel="Ausgewählt"
                                 deselectLabel=""
                                 group-label="wholesaler"
                                 group-values="merchants"
                                 label="name"
                                 selectLabel=""
                                 track-by="name"
                                 :preselect-first="true">
                    </multiselect>
                    <div v-if="errors.id" class="invalid-feedback d-block">
                        {{ errors.id[0] }}
                    </div>
                </div>
                <div class="col-12 col-md-4">
                    <button type="submit" class="btn btn-secondary w-100">Standort wählen</button>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
export default {
    name: 'MerchantList',
    props: {
        merchants: {
            type: Array,
        },
        selectedMerchant: {
            type: Object,
        },
    },
    data() {
        return {
            form: null,
            errors: Object,
        };
    },

    mounted() {
        if (this.selectedMerchant) {
            this.form = this.selectedMerchant;
        }
    },

    methods: {
        submit() {
            axios.post('/api/admin/select', this.form).then(response => {
                location.reload();
            }).catch((error => {
                this.errors = error.response.data.errors;
            }));
        },
    },
};
</script>
